export default __webpack_public_path__ + "static/media/slider.ba7e0778.svg";